<template>
  <div class="flex flex-col gap-1 max-h-[314px]">
    <div
      class="grid grid-cols-1 px-3 self-stretch place-items-center items-start"
    >
      <div
        class="p-6u ring-inset ring-border-brand ring-[3px] rounded-full hover:ring-8 transition-all duration-150 flex shrink-0"
      >
        <Avatar :user="data.winner" size="md" :badge="isPaidUser" />
      </div>
    </div>
    <div class="flex flex-col gap-2.5 justify-center items-center text-center">
      <div class="tracking-wide font-serif font-normal px-4">
        <p class="text-lg uppercase">
          {{ data.winner?.username || "Unknown" }}
          <span class="text-blue-500 text-text-brand">
            {{
              $t(
                `channel.contests.${data.type === ContestType.Raffle ? "raffle" : "quiz"}.winner.title`,
              )
            }}
          </span>
        </p>
        <p class="text-text-secondary font-sans text-sm font-medium">
          {{ prizeTitle }}
        </p>
      </div>
    </div>

    <div class="flex items-center overflow-hidden py-30u">
      <img
        class="w-full h-[181px] scale-110 origin-center bg-[rgba(11,17,22,0.89)] shadow-lg border-border-brand flex flex-col justify-start items-start object-cover"
        :src="data.prize?.image || '/contests/default-prize.png'"
        alt="contest prize image"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Avatar from "@/components/me/avatar.vue";
import { computed } from "vue";
import { ContestType, type IContestFinished } from "./contest.types";
import { useObjectTranslation } from "@/stores/translation.store";

const props = defineProps<{
  data: IContestFinished;
  objectName: string;
  variant?: "responsive" | "regular";
  allowSwitchToLeaderboard?: boolean;
}>();

const _emit = defineEmits<{
  close: [];
  delete: [];
}>();

const isPaidUser = computed(() =>
  props.data.winner.user_channel_memberships?.some(
    (cm) => cm.channel_membership?.permission_mask > 0,
  ),
);

const { text: prizeTitle } = useObjectTranslation(
  computed(() => {
    if (!props.data.prize.title) return null;

    return {
      authorUserId: props.data.created_by_id,
      originalText: props.data.prize.title,
      objectAccessors: {
        objectId: props.data.prize.id,
        objectProperty: "title",
      },
      translatedText: props.data.prize.translations[0],
    };
  }),
);
</script>
